const o=0,t=1,c=2,e=3;export{e as FITTING_BOTH,o as FITTING_NONE,c as FITTING_SHRINK,t as FITTING_STRETCH};
